import { React } from 'react'
import styled from 'styled-components'

import Divider from '@material-ui/core/Divider'
import List from '@material-ui/core/List'
import ListSubheader from '@material-ui/core/ListSubheader'
import Typography from '@material-ui/core/Typography'
import Skeleton from '@material-ui/lab/Skeleton'

import { useSelector, shallowEqual } from 'react-redux'
import Dashboard from './DashboardItem'

const StyledDashboardList = styled(List)`
  max-width: 480px;
  height: fit-content;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  &.MuiList-root {
    margin: 40px 0;
  }
  &.MuiList-padding {
    padding: 10px;
  }
`

const DashboardList = () => {
  const { recentDashboards } = useSelector(({ recentRecords }) => {
    return {
      recentDashboards: recentRecords.recentDashboards
    }
  }, shallowEqual)

  return (
    <StyledDashboardList>
      <ListSubheader component="div">
        <Typography variant="h6" component="div">
          Dashboards
        </Typography>
      </ListSubheader>
      <Divider />
      {recentDashboards.length ? (
        recentDashboards.map((dashboard) => {
          return <Dashboard dashboard={dashboard} key={dashboard.dashboardId} />
        })
      ) : (
        <>
          <Skeleton height={48} />
          <Skeleton height={48} />
          <Skeleton height={48} />
          <Skeleton height={48} />
          <Skeleton height={48} />
        </>
      )}
    </StyledDashboardList>
  )
}

export default DashboardList
